export default __webpack_public_path__ + "static/media/cover_bingo.50af3c47.mp4";